.paste-input-toggle {
  grid-column: 1 / span 12;
  text-align: right;
}

.paste-input-toggle-small {
  white-space: nowrap;
  line-height: 28px;
  font-size: 14px;
  place-self: end flex-end;
  grid-row: 1;
  grid-column: 8 / span 5;
  cursor: pointer;
  display: flex;

  :hover {
    text-decoration: underline;
  }

  .paste-input-toggle-icon {
    height: 28px;
    width: 30px;
  }
}

.paste-address-entry {
  grid-column: 2 / span 11;
}

.paste-address-field {
  grid-column: 2 / span 11;
}
